export function deepClone<T>(value: T): T {
    return value == null ? (value as T) : JSON.parse(JSON.stringify(value));
}

export default deepClone;
